export enum UNITS {
  KWP = "kWp",
  MWP = "MWp",
}
